import { gql } from 'apollo-angular';

export const GET_IF_CONTROL_TOWER_IS_ENABLED_FOR_THE_ORG_BY_ORG_ID_QUERY = gql`
  query GetOrganizationById($orgId: String!) {
    getOrganizationById(orgId: $orgId) {
      controlTowerEnabled
      onlyFreightForwarder
      landingPageUrl
    }
  }
`;

export type GetIfControlTowerIsEnabledForTheOrgByIdDTO = {
  getOrganizationById: {
    controlTowerEnabled: boolean;
    onlyFreightForwarder: boolean;
    landingPageUrl?: string;
  };
};
